module.exports = __webpack_public_path__ + "img/male-ico.037e22c9.svg";